import type { EntityType } from '@/rtk/entityInfoApi';

export type MenuFlags = {
  isEngineer: boolean;
  isDiagnosticPageActive: boolean;
  isUpdatesPageActive: boolean;
  isAmfDataExplorerPageActive: boolean;
  isHeatmapPageActive: boolean;
  isVectorSettingsPageActive: boolean;
};

export type EntityMenuOption = {
  menuTitle: string;
  iconClass: string;
  appendixUrl: string;
  overviewParam?: boolean;
  isVisible?: (flags: MenuFlags) => boolean;
};

export const ENTITY_MENU_OPTIONS: Partial<
  Record<EntityType, EntityMenuOption[]>
> = {
  AstronautA5Next: [
    {
      menuTitle: 'overview',
      iconClass: 'lely-icon-activities',
      appendixUrl: 'astronaut/overview',
    },
    {
      menuTitle: 'diagnostics',
      iconClass: 'lely-icon-reports',
      appendixUrl: 'astronaut/domains/canbus',
      isVisible: (flags) => flags.isDiagnosticPageActive,
    },
    {
      menuTitle: 'dataExplorer',
      iconClass: 'lely-icon-graph-view',
      appendixUrl: 'astronaut/data-explorer',
      overviewParam: true,
    },
    {
      menuTitle: 'events',
      iconClass: 'lely-icon-tasks',
      appendixUrl: 'astronaut/events',
    },
    {
      menuTitle: 'logs',
      iconClass: 'lely-icon-table',
      appendixUrl: 'astronaut/logs',
      isVisible: (flags) => flags.isEngineer,
    },
    {
      menuTitle: 'settings',
      iconClass: 'lely-icon-settings',
      appendixUrl: 'astronaut/settings',
    },
    {
      menuTitle: 'updates',
      iconClass: 'lely-icon-update',
      appendixUrl: 'astronaut/updates',
      isVisible: (flags) => flags.isUpdatesPageActive,
    },
  ],
  VectorSystem: [
    {
      menuTitle: 'dataExplorer',
      iconClass: 'lely-icon-graph-view',
      appendixUrl: 'vector/data-explorer',
    },
    {
      menuTitle: 'performanceIndicators',
      iconClass: 'lely-icon-graph',
      appendixUrl: 'vector/performance-indicators',
    },
    {
      menuTitle: 'events',
      iconClass: 'lely-icon-tasks',
      appendixUrl: 'vector/events',
    },
    {
      menuTitle: 'settings',
      iconClass: 'lely-icon-settings',
      appendixUrl: 'vector/settings',
      isVisible: (flags) => flags.isVectorSettingsPageActive,
    },
  ],
  AutomaticMilkFilter: [
    {
      menuTitle: 'settings',
      iconClass: 'lely-icon-settings',
      appendixUrl: 'amf/settings',
    },
    {
      menuTitle: 'events',
      iconClass: 'lely-icon-tasks',
      appendixUrl: 'amf/events',
    },
    {
      menuTitle: 'dataExplorer',
      iconClass: 'lely-icon-graph-view',
      appendixUrl: 'amf/data-explorer',
      isVisible: (flags) => flags.isAmfDataExplorerPageActive,
    },
  ],
  Discovery: [
    {
      menuTitle: 'logs',
      iconClass: 'lely-icon-table',
      appendixUrl: 'discovery/logs',
    },
    {
      menuTitle: 'eventsHeatmap',
      iconClass: 'lely-icon-map-search',
      appendixUrl: 'discovery/events-heatmap',
      isVisible: (flags) => flags.isHeatmapPageActive,
    },
  ],
  AstronautMax: [
    {
      menuTitle: 'dataExplorer',
      iconClass: 'lely-icon-graph-view',
      appendixUrl: 'astronaut-max/data-explorer',
    },
  ],
  NCapture: [
    {
      menuTitle: 'dataExplorer',
      iconClass: 'lely-icon-graph-view',
      appendixUrl: 'n-capture/data-explorer',
    },
  ],
  Juno: [
    {
      menuTitle: 'logs',
      iconClass: 'lely-icon-table',
      appendixUrl: 'juno/logs',
    },
  ],
};

export const getInitials = (name: string): string =>
  name
    .split(/[\s._-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join('');
